const enum LoggerLevel {
    ERROR,
    info,
    DEBUG,
}

const conzole = console;

const level = LoggerLevel.DEBUG;

const hint = '[TrackReport]: ';

export function loggerInfo(...args) {
    if (LoggerLevel.info <= level) {
        conzole.trace(hint, ...args);
    }
}

export function loggerError(...args) {
    if (LoggerLevel.ERROR <= level) {
        conzole.error(hint, ...args);
    }
}

export function loggerDebug(...args) {
    if (LoggerLevel.DEBUG <= level) {
        conzole.trace(hint, ...args);
    }
}
